<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <guide-list
        v-bind:guides="guideList"
        v-on:addGuide="addGuide"
        v-on:viewGuide="viewGuide"
        v-on:deleteGuide="deleteGuide"
      ></guide-list>
    </div>
    <div class="md-layout-item md-size-50">
      <guide-edit
        v-bind:guide="selectedGuide"
        v-on:guideUpdated="guideUpdated"
      ></guide-edit>
    </div>
  </div>
</template>

<script>
import guideApi from "@/services/api/guide";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import Swal from "sweetalert2";

import GuideList from "./GuideList";
import GuideEdit from "./GuideEdit";

export default {
  components: {
    GuideList,
    GuideEdit
  },

  data() {
    return {
      selectedGuide: null,
      guideList: []
    };
  },

  methods: {
    getGuides() {
      guideApi.getAll().then(response => {
        this.guideList = response.data;
      });
    },

    addGuide() {
      this.selectedGuide = {};
    },

    viewGuide(guide) {
      this.selectedGuide = { ...guide };
    },

    deleteGuide(guide) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          guideApi.delete(guide.id).then(response => {
            this.guideList = _filter(this.guideList, function(a) {
              return a.id !== guide.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });

            this.selectedGuide = null;
          });
        }
      });
    },

    guideUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.guideList.unshift(updateInfo.guide);
      } else {
        var index = _findIndex(this.guideList, {
          id: updateInfo.guide.id
        });
        this.guideList.splice(index, 1, updateInfo.guide);
      }

      this.selectedGuide = null;
    }
  },

  mounted() {
    this.getGuides();
  }
};
</script>
